import { gql } from '@apollo/client'

export default gql(`
    mutation deleteVirtualSeriesSeasons($input: [ID] $assetId: ID $project: String $module: String) {
        deleteVirtualSeriesSeasons(
            input: $input
            assetId: $assetId
            project: $project
            module: $module
        )
    }`
)
